import React, { useEffect } from "react";
import "./promotions-main.scss";
import FindGame from "../landing/find_game/FindGame";
import StaticBonus from "./static_bonus/StaticBonus";
import Back from "../mui/back/Back";
import IconBonus from "../mui/JSXIcons/IconBonus";
import ErrorBoundary from "../mui/error_boundary/ErrorBoundary.jsx";
import useGetLink from "../../hooks/other/useGetLink.js";
import { dispatchCusEvent } from "../../utils/utils.js";
import { ENUM_COMMON_EVENT } from "../../hooks/common/useListener.js";

export default function PromotionsMain() {
  const home = useGetLink("/");

  useEffect(() => {
    dispatchCusEvent(ENUM_COMMON_EVENT.getBonus);
  }, []);

  return (
    <section className="promotions">
      <Back icon={<IconBonus />} to={home} title={"Bonuses and promotions"} />
      <FindGame inputId={"promo__find-game"} />
      <ErrorBoundary>
        <StaticBonus />
      </ErrorBoundary>
    </section>
  );
}
